import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/egalite-incluipcd/egalite-incluipcd/apps/incluipcd/src/blocks/Sponsor/Hero/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/egalite-incluipcd/egalite-incluipcd/apps/incluipcd/src/blocks/Sponsor/Jobs/index.tsx");
